import "./orders.css";
import FreePage from "./FreePage";
import Image from "./Images/orders.png";
import { useEffect, useState } from "react";
import { getUserOrders } from "../../network/api/order.js";
import { useNavigate } from "react-router-dom";
import ReturnRequest from "./cancelorderandreturnreplace/ReturnRequest.js";
import ReplaceRequest from "./cancelorderandreturnreplace/ReplaceRequest.js";
import CancelOrder from "./cancelorderandreturnreplace/CancelOrder.js";
import CardItem from "./CardItem.jsx";
import Title from "./Title.jsx";
import { useTranslation } from "react-i18next";

function Orders({ getUserName }) {
  const { t } = useTranslation();
  const [free, setFree] = useState(true);
  const [orders, setOrders] = useState([]);
  const [showReturn, setShowReturn] = useState(false);
  const [showReplace, setShowReplace] = useState(false);
  const [cancelOrder, setcancelOrder] = useState(false);
  const [refreshComp, setRefreshComponent] = useState(false);
  const [currentOrderId, seCurrentOrderId] = useState("");
  const navigate = useNavigate();

  const handelShowReturn = (id) => {
    seCurrentOrderId(id);
    setShowReturn(true);
  };
  const handelShowReplace = (id) => {
    seCurrentOrderId(id);
    setShowReplace(true);
  };

  const handelShowCancelOrder = (id) => {
    seCurrentOrderId(id);
    setcancelOrder(true);
  };

  const handelCloseReturn = () => {
    setShowReturn(false);
  };
  const handelCloseReplace = () => {
    setShowReplace(false);
  };
  const handelCloseCancelOrder = () => {
    setcancelOrder(false);
  };

  useEffect(() => {
    getUserOrders().then((result) => {
      if (result && result.length > 0) {
        setOrders(result);
        setFree(false);
      } else {
        setFree(true);
      }
    });
  }, [refreshComp]);

  const homePageHandler = () => {
    navigate("/");
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const formatter = new Intl.DateTimeFormat("ar-EG", {
      day: "numeric",
      month: "long",
    });
    return formatter.format(date);
  };
  return (
    <div className="orders-page flex-grow-1 w-100">
      <Title title={getUserName} text="أهلا بك فى حسابك" />
      <div>
        <ReturnRequest
          setRefreshComponent={setRefreshComponent}
          show={showReturn}
          setShowReturn={setShowReturn}
          onHide={handelCloseReturn}
          orderId={currentOrderId}
        />
        <ReplaceRequest
          setRefreshComponent={setRefreshComponent}
          show={showReplace}
          setShowReplace={setShowReplace}
          onHide={handelCloseReplace}
          orderId={currentOrderId}
        />
        <CancelOrder
          setRefreshComponent={setRefreshComponent}
          show={cancelOrder}
          setcancelOrder={setcancelOrder}
          onHide={handelCloseCancelOrder}
          orderId={currentOrderId}
        />
        {free ? (
          <div className="d-flex flex-column orders">
            <FreePage
              prev={true}
              prevName="اعرض الطلبيات السابقة "
              image={OrdersIcon}
              contentP="ما في طلبيـات سابقة "
              contentSpan="ابدأالتسوق اليوم !"
              btn="ابدأبالتسوق"
              btnValue={homePageHandler}
            />
          </div>
        ) : (
          <>
            {orders?.map((order, index) => (
              <>
                <div className="card-item">
                  <div className="d-flex justify-content-between align-items-center px-2">
                    <p className="date">{formatDate(order.createdAt)}</p>
                    {/* <div className="price d-flex align-items-center gap-2 text-dark">
                      <span >{t("curency")}</span>
                      <span className="text-primary fw-bold fs-5">{order?.totalPrice}</span>
                    </div> */}
                  </div>
                  <>
                    {order.products.map((product, index) => (
                      <CardItem
                        id={product.product_id}
                        key={index}
                        image={product.image[0].secure_url}
                        name={product.name}
                        desc={product.description}
                        color={product.color}
                        size={product.size}
                        quantStart={product.quantity}
                        price={order.totalPrice}
                        status={order.status}
                        product={product}
                      />
                    ))}
                  </>
                  <div className="">
                    {order.status && (
                      <>
                        {order.status === "shipped" && (
                          <div className="stats pt-2 px-1">
                            <p className="processing bg-dark" style={{width: "fit-content"}}>{order.status}</p>
                          </div>
                        )}

                        {order.status === "processing" && (
                          <div className="stats d-flex justify-content-between align-items-center pt-2 px-1">
                            <p className="processing">{order.status}</p>
                            <button
                              title="Processing"
                              onClick={() => {
                                handelShowCancelOrder(order._id);
                              }}
                            >
                              Cancel Order
                            </button>
                          </div>
                        )}
                        {order.status === "delivered" && (
                          <div className="stats d-flex justify-content-between align-items-center pt-2 px-1">
                            <p className="return">{order.status}</p>
                            <div className="d-flex text-center flex-md-row mt-2 gap-2">
                              <button
                                title="Return Request"
                                onClick={() => {
                                  handelShowReturn(order._id);
                                }}
                              >
                                Return Request
                              </button>

                              <button
                                title="Return Request"
                                onClick={() => {
                                  handelShowReplace(order._id);
                                }}
                              >
                                Replace Request
                              </button>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
export default Orders;

const OrdersIcon = (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6667 7.63142L14.6035 6.77956C14.5456 5.99919 13.8712 5.39457 13.0587 5.39457H11.4033M5.5 15.8332H4.54878C3.65 15.8332 2.93998 15.0989 3.00402 14.2357L3.55712 6.77956C3.61501 5.99919 4.28938 5.39457 5.10188 5.39457H6.75725M6.75725 5.39457V3.90335C6.75725 2.66797 7.79732 1.6665 9.0803 1.6665C10.3633 1.6665 11.4033 2.66797 11.4033 3.90335V5.39457M6.75725 5.39457H11.4033M14.6667 12.4998C14.6667 13.4203 13.9205 14.1665 13 14.1665C12.0795 14.1665 11.3333 13.4203 11.3333 12.4998M9.66667 17.4998H16.3333C17.2538 17.4998 18 16.7536 18 15.8332V11.6665C18 10.746 17.2538 9.99984 16.3333 9.99984H9.66667C8.74619 9.99984 8 10.746 8 11.6665V15.8332C8 16.7536 8.74619 17.4998 9.66667 17.4998Z"
      stroke="white"
      stroke-width="1.25"
      stroke-linecap="round"
    />
  </svg>
);
